var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-view"},[_c('page-header',{attrs:{"title":"Hakkımızda"}}),_c('our-mission'),_c('team'),_c('faq')],1)}
var staticRenderFns = []

export { render, staticRenderFns }